import { DatePipe } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
// Seguridad token
import { JwtModule, JWT_OPTIONS } from '@auth0/angular-jwt';
import { ToastrModule } from 'ngx-toastr';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
// INTERCEPTOR  para chequear e interceptar las llamadas y ver si es 401 o cualquier error global que queramos detectar
import { AuthInterceptorService } from './core/interceptors/auth-interceptor.service';
import { FileDownloaderService } from './core/services/file-downloader.service';
import { HomeModuleModule } from './home/home-module.module';
import { LoginModule } from './login/login-module.module';
import { MaintenanceComponent } from './maintenance.component';
import { SharedModule } from './shared/shared.module';
import { BearerService } from './core/services/bearer-service.service';
import { UtcDatePipe } from './core/pipes/utc-date-pipe';
// Importamos módulos


export function getToken(): string {
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    const token = currentUser && currentUser.token;
    const toReturn = token ? token : '';
    return toReturn;
}

export function jwtOptionsFactory(bearerService: BearerService) {
    const bearerStorage = bearerService.getBearer();
    return {
        tokenGetter: getToken,
        whitelistedDomains: [environment.API_DOMAIN],
        authScheme: bearerStorage
    };
}

@NgModule({
    declarations: [AppComponent, MaintenanceComponent],
    imports: [
        HomeModuleModule,
        LoginModule,
        AppRoutingModule,
        SharedModule,
        BrowserModule,
        BrowserAnimationsModule,
        ToastrModule.forRoot({
            timeOut: 10000,
            closeButton: true,
            positionClass: 'toast-top-right',
            maxOpened: 15,
            newestOnTop: true,
            enableHtml: false,
            messageClass: '',
            titleClass: ''
        }),
        CoreModule,
        JwtModule.forRoot({
            jwtOptionsProvider: {
                provide: JWT_OPTIONS,
                useFactory: jwtOptionsFactory,
                deps: [BearerService]
            }
        }),
        // JwtModule.forRoot({
        //     config: {
        //         tokenGetter: getToken,
        //         whitelistedDomains: [environment.API_DOMAIN],
        //         authScheme: bearer
        //     }
        // })
    ],
    providers: [
        BearerService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptorService,
            multi: true
        }, DatePipe,
        UtcDatePipe,
        FileDownloaderService

    ],
    bootstrap: [AppComponent]
})
export class AppModule { }

